import P2Medium from 'components/typography/P2Medium';
import { UserRow } from 'components/tables/data/user/types';

/**
 * Column for the organization name.
 */
export default function OrganizationNameColumn({ data: { organization } }: { data: UserRow }) {
  return <P2Medium color="gray.8">{organization.organizationName}</P2Medium>;
}
